import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
  loadPerformers,
  setPeriod,
  setType,
  setLevType,
  setTopN,
  setFundCcy,
  setCobDate,
  setSort,
  setTier1Cat,
  setTier2Cat,
  setCurrency
} from '../../actions'
import {
  getSelectedCurrencyOption,
  getCurrencyOption,
  getSelectedTier1CatOption,
  getTier1CatOption,
  getSelectedTier2CatOption,
  getTier2CatOption,
  getInitialLoad
} from '../../reducers'
import DatePicker from './DatePicker'
import Select from 'react-select-v2'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import i18n from '../../i18n'
import * as constants from '../../services/Constants'

import './style.css'

library.add(faCircleNotch)

const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 0
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#050139',
    // width:  '100px',
    fontSize: 12,
    // boxShadow: `0 0 0 1px 'orange'`, //?
    ':active': {
      backgroundColor: state.isSelected ? 'white' : '#050139',
      color: state.isSelected ? '#050139' : 'white'
    },
    ':hover': {
      backgroundColor: state.isSelected ? 'white' : '#050139',
      color: state.isSelected ? '#050139' : 'white'
    }
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 0,
    borderColor: '#050139'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 100ms'

    return { ...provided, opacity, transition }
  },
  multiValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 0.75
    const fontSize = '14px'
    const zIndex = 9999
    return { ...provided, opacity, fontSize, zIndex }
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: '#050139'
  })
}

const formatDate = (string) => {
  //just split string for now
  var split = string.split('-')
  return split[1] + '/' + split[2] + '/' + split[0]
}

const arrayToFormOptions = (values) => {
  return values.map((item) => ({ value: item, label: item }))
}

const valueToFormValue = (value) => {
  if (value && value.length > 0) {
    return value.map((item) => ({ value: item, label: item }))
  } else {
    return null
  }
}

const perfColumnName = (period) => {
  console.log('props.period', period)
  switch (period) {
    case constants.BTN_DLY:
    case constants.BTN_MTD:
    case constants.BTN_QTD:
    case constants.BTN_YTD:
    case constants.BTN_3M:
      return i18n.t('Cumulative') + '<br />' + i18n.t('Returns')
    default:
      return i18n.t('Average Annual') + '<br />' + i18n.t('Total Returns')
  }
}

const asOfDate = (entities) => {
  if (entities.length > 0) {
    const date = new Date(entities[0].asOfDate)
    const day = date.getUTCDate()
    const month = date.getUTCMonth()
    const year = date.getUTCFullYear()
    const asOfDate = new Date(year, month, day)
    return asOfDate
  } else {
    const prevBusDay = new Date()
    prevBusDay.setDate(prevBusDay.getDate() - 1)
    if (prevBusDay.getDay() === 0) {
      prevBusDay.setDate(prevBusDay.getDate() - 2)
    } else if (prevBusDay.getDay() === 6) {
      // Sat, minus one day to get to Friday
      prevBusDay.setDate(prevBusDay.getDate() - 1)
    }
    return prevBusDay
  }
}

const asOfDateText = (wtRegion, entities) => {
  const isoCode = wtRegion === constants.REGION_US ? constants.REGION_ISO_US : constants.REGION_ISO_GB
  return i18n.t('As of') + ' ' + new Intl.DateTimeFormat(isoCode).format(asOfDate(entities))
}

const App = (props) => {
  const [datePickerVisible, setDatePicker] = useState(false)
  const [isShortAndLev, setIsShortAndLev] = useState(false)
  const [periodColName, setPeriodColName] = useState(i18n.t('Cumulative') + '<br />' + i18n.t('Returns'))
  const {
    loadPerformers,
    setTopN,
    setPeriod,
    setSort,
    setFundCcy,
    topn,
    selectedTier1CatOption,
    selectedTier2CatOption,
    tier1CatOption,
    tier2CatOption,
    setTier1Cat,
    setTier2Cat,
    data,
    calendarStart,
    levType,
    setLevType,
    entities,
    wtRegion,
    setCobDate,
    period,
    setType,
    type: btnSelectedType,
    selectedCurrencyOption,
    sortColumn,
    sortDirection,
    showTopnNumButtons,
    timePeriod01_button,
    timePeriod03_button,
    timePeriod05_button,
    timePeriod10_button,
    showDatePicker,
    initialLoad
  } = props

  const yearStart = calendarStart.substr(0, 4)
  const monthStart = parseInt(calendarStart.substr(4, 2)) - 1
  const dayStart = calendarStart.substr(4, 2)
  const calendarStartDate = wtRegion === 'GB' ? new Date(yearStart, monthStart, dayStart) : new Date(2006, 6, 30)
  const calandarEndDate = new Date(Date.now() - 86400000)
  const levTypeOptions = [i18n.t('Unleveraged'), i18n.t('ShortAndLeveraged')]

  useEffect(() => {
    const init = async () => {
      await loadPerformers()
    }
    init()
  }, [])

  const setTopBottom = (value) => {
    switch (value) {
      case 'top':
        setTopN(topn < 0 ? -1 * topn : topn)
        break
      case 'bot':
        setTopN(topn > 0 ? -1 * topn : topn)
        break
      default:
        break
    }
  }

  const setSortData = (column) => {
    setSort(column)
  }

  const setFundNum = (value) => {
    setTopN(topn < 0 ? -1 * value : value)
  }

  const setPeriodName = (period) => {
    setPeriod(period)
    setPeriodColName(perfColumnName(period))
  }

  const toggleDatePicker = () => {
    setDatePicker(!datePickerVisible)
  }

  const handleDatePickerSubmit = (theDate) => {
    const day = theDate.getDate()
    const month = theDate.getUTCMonth() + 1
    const year = theDate.getUTCFullYear()
    const asOfDate = month + '/' + day + '/' + year
    console.log('DatePicker setting COB ', asOfDate)

    setCobDate(asOfDate)
    toggleDatePicker()
  }

  const buttonTypeClass = (type) => {
    return type === btnSelectedType ? 'button-selected' : ''
  }

  const setLeverageType = (levType) => {
    setLevType(levType)
    setIsShortAndLev(levType.value === i18n.t('ShortAndLeveraged'))
  }

  const buttonPeriodClass = (type) => {
    return type === period ? 'button-selected' : ''
  }

  const buttonTopBottomClass = (value) => {
    switch (value) {
      case 'top':
        return topn > 0 ? 'button-selected' : ''
      case 'bot':
        return topn < 0 ? 'button-selected' : ''
      default:
        return ''
    }
  }

  const buttonFundNumClass = (value) => {
    return value === Math.abs(topn) ? 'button-selected' : ''
  }

  const buttonFundCcyClass = (value) => {
    return value === selectedCurrencyOption ? 'button-selected' : ''
  }

  const setTblHeadClass = (type) => {
    if (type === sortColumn && sortDirection === 'DESC') {
      return 'des'
    } else if (type === sortColumn && sortDirection === 'ASC') {
      return 'asc'
    } else {
      return ''
    }
  }

  const renderEntities = () => {
    const dateFormat = {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric'
    }

    const nfp = new Intl.NumberFormat([constants.REGION_ISO_US], {
      style: 'percent',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    if (initialLoad === false) {
      return (
        <tr>
          <td colSpan="11" style={{ textAlign: 'center' }}>
            <FontAwesomeIcon icon="circle-notch" size="3x" style={{ color: '#050139' }} spin />
          </td>
        </tr>
      )
    } else if (entities && wtRegion === constants.REGION_US) {
      return entities.map((entity, idx) => (
        <tr key={`${entity.wtListingID}-${idx}`}>
          <td width="90" rowname="Ticker" style={{ textAlign: 'left' }}>
            <a href={entity.fundURL} target="_new">
              {entity.ticker}
            </a>
          </td>
          <td width="120" rowname="Fund" style={{ textAlign: 'left' }}>
            <div>{entity.fundName.replace(/&amp;/g, '&')}</div>
          </td>
          <td width="90" rowname="Category" className="textCenter" style={{ textAlign: 'center' }}>
            <div>{entity.typeCat}</div>
          </td>
          <td width="90" rowname="Inception Date" style={{ textAlign: 'center' }}>
            {formatDate(entity.inceptionDate)}
            {/* {new Date(entity.inceptionDate).toISOString()       
            } */}
          </td>
          <td width="90" rowname="Cummulative Returns" style={{ textAlign: 'center' }}>
            {nfp.format(entity[period + btnSelectedType])}
          </td>
        </tr>
      ))
    } else if (entities && wtRegion !== constants.REGION_US) {
      return entities.map((entity, idx) => (
        <tr key={`${entity.wtListingID}-${idx}`}>
          <td width="115" rowname="Ticker" style={{ textAlign: 'center' }}>
            {entity.ticker.substring(0, entity.ticker.length - 2)}
          </td>
          <td width="140" rowname="Fund" style={{ textAlign: 'left' }}>
            <a href={entity.fundURL} target="_new">
              {entity.fundName.replace(/&amp;/g, '&')}
            </a>
          </td>
          <td width="120" rowname="Category" style={{ textAlign: 'center' }}>
            <div>{entity.typeCat}</div>
          </td>
          <td width="50" rowname="BaseCcy" style={{ textAlign: 'center' }}>
            <div>{entity.baseCCY}</div>
          </td>
          <td width="50" rowname="PerfCcy" style={{ textAlign: 'center' }}>
            <div>{entity.performanceCCY}</div>
          </td>
          {/* <td rowname='ListCcy'>
            <div>{entity.listingCCY}</div>
          </td> */}
          <td width="80" rowname="Inception Date" style={{ textAlign: 'center' }}>
            {new Date(entity.inceptionDate).toLocaleString(constants.REGION_ISO_GB, dateFormat)}
          </td>
          <td width="80" rowname="Cummulative Returns" style={{ textAlign: 'center' }}>
            {nfp.format(entity[period + btnSelectedType])}
          </td>
        </tr>
      ))
    } else {
      return null
    }
  }

  if (data) {
    return (
      <div className="top-perf">
        <div className="perf-btn-toolbar justify-content-between">
          <div className="row">
            {wtRegion !== constants.REGION_US && (
              <div className="selectrow">
                <div style={{ zIndex: '951' }} className="selectrowitem">
                  <Select
                    placeholder={i18n.t('AllProductTypes')}
                    styles={customStyles}
                    onChange={setLeverageType}
                    options={arrayToFormOptions(levTypeOptions.filter((type) => type !== levType))}
                    value={valueToFormValue([levType])}
                    closeMenuOnSelect
                  />
                </div>
              </div>
            )}
          </div>
          <div className="row">
            {wtRegion === constants.REGION_US && (
              <div className="perf-btn-group left">
                <button className={buttonTypeClass('Nav')} onClick={() => setType('Nav')}>
                  {i18n.t('NAV')}
                </button>
                <button className={buttonTypeClass('MP')} onClick={() => setType('MP')}>
                  {i18n.t('Market Price')}
                </button>
              </div>
            )}

            {wtRegion !== constants.REGION_US && (
              <div id="currency" className="perf-btn-group left">
                <button className={buttonFundCcyClass(constants.CUR_EUR)} onClick={() => setFundCcy(constants.CUR_EUR)}>
                  {constants.CUR_EUR}
                </button>
                <button className={buttonFundCcyClass(constants.CUR_GBP)} onClick={() => setFundCcy(constants.CUR_GBP)}>
                  {constants.CUR_GBP}
                </button>
                <button className={buttonFundCcyClass(constants.CUR_USD)} onClick={() => setFundCcy(constants.CUR_USD)}>
                  {constants.CUR_USD}
                </button>
                <button className={buttonFundCcyClass(constants.CUR_CHF)} onClick={() => setFundCcy(constants.CUR_CHF)}>
                  {constants.CUR_CHF}
                </button>
              </div>
            )}

            <div className="perf-btn-group left">
              <button
                className={buttonTopBottomClass(constants.BTN_TOP)}
                onClick={() => setTopBottom(constants.BTN_TOP)}
              >
                {i18n.t('Top')}
              </button>
              <button
                className={buttonTopBottomClass(constants.BTN_BOTTOM)}
                onClick={() => setTopBottom(constants.BTN_BOTTOM)}
              >
                {i18n.t('Bottom')}
              </button>
            </div>

            {showTopnNumButtons && (
              <div id="number" className="perf-btn-group left">
                <button className={buttonFundNumClass(5)} onClick={() => setFundNum(5)}>
                  5
                </button>
                <button className={buttonFundNumClass(10)} onClick={() => setFundNum(10)}>
                  10
                </button>
                {wtRegion !== constants.REGION_US && (
                  <div>
                    <button className={buttonFundNumClass(25)} onClick={() => setFundNum(25)}>
                      25
                    </button>
                    <button className={buttonFundNumClass(1000)} onClick={() => setFundNum(1000)}>
                      All
                    </button>
                  </div>
                )}
              </div>
            )}

            <div id="period" className="perf-btn-group" style={{ marginLeft: 'auto', marginRight: '15px' }}>
              <button className={buttonPeriodClass(constants.BTN_DLY)} onClick={() => setPeriodName(constants.BTN_DLY)}>
                {i18n.t('DLY')}
              </button>
              <button className={buttonPeriodClass(constants.BTN_MTD)} onClick={() => setPeriodName(constants.BTN_MTD)}>
                {i18n.t('MTD')}
              </button>
              <button className={buttonPeriodClass(constants.BTN_QTD)} onClick={() => setPeriodName(constants.BTN_QTD)}>
                {i18n.t('QTD')}
              </button>
              <button
                id="ytd"
                className={buttonPeriodClass(constants.BTN_YTD)}
                onClick={() => setPeriodName(constants.BTN_YTD)}
              >
                {i18n.t('YTD')}
              </button>
              {/* </div>
  
            <div id='period2' className='perf-btn-group left'> */}
              <button className={buttonPeriodClass(constants.BTN_3M)} onClick={() => setPeriodName(constants.BTN_3M)}>
                {i18n.t('3M')}
              </button>
              {timePeriod01_button && (
                <button className={buttonPeriodClass(constants.BTN_1Y)} onClick={() => setPeriodName(constants.BTN_1Y)}>
                  {i18n.t('1Y')}
                </button>
              )}
              {timePeriod03_button && (
                <button className={buttonPeriodClass(constants.BTN_3Y)} onClick={() => setPeriodName(constants.BTN_3Y)}>
                  {i18n.t('3Y')}
                </button>
              )}
              {timePeriod05_button && (
                <button className={buttonPeriodClass(constants.BTN_5Y)} onClick={() => setPeriodName(constants.BTN_5Y)}>
                  {i18n.t('5Y')}
                </button>
              )}
              {timePeriod10_button && (
                <button
                  className={buttonPeriodClass(constants.BTN_10Y)}
                  onClick={() => setPeriodName(constants.BTN_10Y)}
                >
                  {i18n.t('10Y')}
                </button>
              )}
            </div>
          </div>

          <div className="selectrow">
            <div style={{ zIndex: '900' }} className="selectrowitem">
              <Select
                placeholder={i18n.t('AllAssetClasses')}
                styles={customStyles}
                isMulti
                onChange={(cat) => {
                  setPeriodName(constants.BTN_YTD)
                  setTier1Cat(cat)
                }}
                options={arrayToFormOptions(tier1CatOption)}
                value={valueToFormValue(selectedTier1CatOption)}
                closeMenuOnSelect={false}
              />
            </div>
            <div style={{ zIndex: '950' }} className="selectrowitem">
              <Select
                placeholder={i18n.t('AllSubAssetClasses')}
                styles={customStyles}
                isMulti
                onChange={(cat) => {
                  setPeriodName(constants.BTN_YTD)
                  setTier2Cat(cat)
                }}
                options={arrayToFormOptions(tier2CatOption)}
                value={valueToFormValue(selectedTier2CatOption)}
                closeMenuOnSelect={false}
              />
            </div>

            <div
              className="perf-btn-group"
              style={{
                marginLeft: 'auto',
                marginRight: '0px',
                marginTop: '0px'
              }}
            >
              {showDatePicker === false && (
                <div id="date-picker">
                  <button id="cal-but">{asOfDateText(wtRegion, entities)}</button>
                </div>
              )}
              {showDatePicker === true && (
                <div id="date-picker">
                  <button id="cal-but" onClick={() => toggleDatePicker()}>
                    {asOfDateText(wtRegion, entities)}
                  </button>
                </div>
              )}
              <div className="DatePicker-container">
                {datePickerVisible && showDatePicker !== false && (
                  <DatePicker
                    selectedDate={asOfDate(entities)}
                    availableTimeRange={[calendarStartDate, calandarEndDate]}
                    message={`Select as of date`}
                    onCancel={() => toggleDatePicker()}
                    onSubmit={handleDatePickerSubmit}
                  />
                )}
              </div>
            </div>
          </div>
          {/* <div className='clearfix' /> */}
          {wtRegion === constants.REGION_US && (
            <div className="perf-details  table-responsive">
              <table id="table-to-xls" className="table">
                <thead>
                  <tr>
                    <th
                      rowname="Ticker"
                      style={{ textAlign: 'left', padding: '16 px' }}
                      className={setTblHeadClass('ticker')}
                      onClick={() => setSortData('ticker')}
                    >
                      {i18n.t('Ticker')}
                    </th>
                    <th
                      rowname="Fund"
                      style={{ textAlign: 'left' }}
                      className={setTblHeadClass('fundName')}
                      onClick={() => setSortData('fundName')}
                    >
                      {i18n.t('Fund')}
                    </th>
                    <th
                      rowname="Category"
                      style={{ textAlign: 'center' }}
                      className={setTblHeadClass('typeCat')}
                      onClick={() => setSortData('typeCat')}
                    >
                      {i18n.t('Category')}
                    </th>
                    <th
                      rowname="Inception Date"
                      className={setTblHeadClass('inceptionDate')}
                      onClick={() => setSortData('inceptionDate')}
                      style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
                    >
                      {i18n.t('InceptionDate')}
                    </th>
                    <th
                      rowname="Cummulative Returns"
                      className={setTblHeadClass('returns')}
                      onClick={() => setSortData('returns')}
                      style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
                      dangerouslySetInnerHTML={{
                        __html: periodColName
                      }}
                    ></th>
                  </tr>
                </thead>
                <tbody>{renderEntities()}</tbody>
              </table>
              {entities.length === 0 && initialLoad === true && <div className="noData">No Data To Display</div>}
            </div>
          )}
          {wtRegion !== constants.REGION_US && (
            <div className="perf-details table-responsive">
              <table id="table-to-xls" className="table table-eu">
                <thead>
                  <tr>
                    <th
                      rowname="Ticker"
                      style={{ textAlign: 'center' }}
                      className={setTblHeadClass('ticker')}
                      onClick={() => setSortData('ticker')}
                    >
                      {i18n.t('Isin')}
                    </th>
                    <th
                      rowname="Fund"
                      style={{ textAlign: 'center' }}
                      className={setTblHeadClass('fundName')}
                      onClick={() => setSortData('fundName')}
                    >
                      {i18n.t('Fund')}
                    </th>
                    <th
                      rowname="Category"
                      style={{ textAlign: 'center' }}
                      className={setTblHeadClass('typeCat')}
                      onClick={() => setSortData('typeCat')}
                    >
                      {i18n.t('Category')}
                    </th>
                    <th
                      rowname="BaseCcy"
                      style={{ textAlign: 'center' }}
                      className={setTblHeadClass('baseCCY')}
                      onClick={() => setSortData('baseCCY')}
                    >
                      {i18n.t('BaseCurrency')}
                    </th>
                    <th
                      rowname="PerfCcy"
                      style={{ textAlign: 'center' }}
                      className={setTblHeadClass('performanceCCY')}
                      onClick={() => setSortData('performanceCCY')}
                    >
                      {i18n.t('PerformanceCurrency')}
                    </th>
                    {/* <th
                      rowname='listCcy'
                      style={{ textAlign: 'left' }}
                      className={setTblHeadClass('listingCCY')}
                      onClick={() => setSortData('listingCCY')}
                    >
                      {i18n.t('Listing Currency')}
                    </th> */}
                    <th
                      rowname="Inception Date"
                      className={setTblHeadClass('inceptionDate')}
                      onClick={() => setSortData('inceptionDate')}
                      style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
                    >
                      {i18n.t('InceptionDate')}
                    </th>
                    <th
                      rowname="Cummulative Returns"
                      className={setTblHeadClass('returns')}
                      onClick={() => setSortData('returns')}
                      style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
                      dangerouslySetInnerHTML={{
                        __html: periodColName
                      }}
                    ></th>
                  </tr>
                </thead>
                <tbody>{renderEntities()}</tbody>
              </table>
              {entities.length === 0 && initialLoad === true && <div className="noData">No Data To Display</div>}
            </div>
          )}
          {wtRegion === constants.REGION_US && (
            <div>
              <div className="perffooter">{i18n.t('comp-stdperf')}</div>
              <div className="perffooter">{i18n.t('comp-perf')}</div>
            </div>
          )}
          {wtRegion !== constants.REGION_US && (
            <div>
              <div className="perffooter text-right text-muted">
                <small>
                  <strong>Source:</strong> WisdomTree, as of{' '}
                  {new Intl.DateTimeFormat(constants.REGION_ISO_GB).format(asOfDate(entities))}
                </small>
              </div>
              <div className="perffooter">
                <strong>{i18n.t('AppDisclaimer')}</strong>
              </div>
              {isShortAndLev && (
                <div className="perffooter">
                  <strong>{i18n.t('S&LDisclaimer')}</strong>
                </div>
              )}
              {!isShortAndLev && (
                <div className="perffooter">
                  <strong>{i18n.t('CryptoDisclaimer')}</strong>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  } else {
    return null
  }
}

function mapStateToProps(state) {
  return {
    tier1CatOption: getTier1CatOption(state),
    selectedTier1CatOption: getSelectedTier1CatOption(state),
    currencyOption: getCurrencyOption(state),
    selectedCurrencyOption: getSelectedCurrencyOption(state),
    tier2CatOption: getTier2CatOption(state),
    selectedTier2CatOption: getSelectedTier2CatOption(state),
    initialLoad: getInitialLoad(state),
    wtRegion: state.performers.wtRegion,
    calendarStart: state.performers.calendarStart,
    period: state.performers.period,
    type: state.performers.type,
    levType: state.performers.levType,
    entities: state.performers.entities,
    topn: state.performers.topn,
    showTopnNumButtons: state.performers.showTopnNumButtons,
    showDatePicker: state.performers.showDatePicker,
    typeCat: state.performers.typeCat,
    typeCat2Option: state.performers.typeCat2Option,
    selectedTypeCat2Option: state.performers.selectedTypeCat2Option,
    typeCats: state.performers.typeCats,
    sortColumn: state.performers.sortColumn,
    sortDirection: state.performers.sortDirection,
    data: state.performers.data,
    timePeriod01_button: state.performers.timePeriod01_button,
    timePeriod03_button: state.performers.timePeriod03_button,
    timePeriod05_button: state.performers.timePeriod05_button,
    timePeriod10_button: state.performers.timePeriod10_button
  }
}

const mapDispatchToProps = {
  loadPerformers,
  setLevType,
  setPeriod,
  setType,
  setTopN,
  setFundCcy,
  setTier1Cat,
  setTier2Cat,
  setCurrency,
  setCobDate,
  setSort
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App/index.js